import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import {observer} from "mobx-react";
import {withStyles} from '@material-ui/core/styles';
import {Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import {Typography} from '@material-ui/core';
import history from '../authentication/History';

const styles = theme => ({});

class Dashboard extends Component
{
    constructor(props)
    {
        super(props);
        this._validAuthStates = ['signedIn'];
    }

    componentDidMount()
    {
        this.props.statStore.getGlobalStats();
    }

    handleBarClick(event)
    {
        if ("clients_id" in event)
        {
            history.push('/clients/' + event.clients_id)
        } else if ("products_id" in event)
        {
            history.push('/products/' + event.products_id)
        } else if ("stickers_id" in event)
        {
            history.push('/stickers/' + event.stickers_id)
        } else if ("orders_id" in event)
        {
            history.push('/orders/' + event.orders_id)
        }
    }

    stripLabel(label)
    {
        if (label.length > 9)
        {
            return label.substring(0, 7) + "..."
        } else
        {
            return label
        }
    }

    render()
    {
        return (
            <div>
                <Grid container
                      direction="row"
                      justify="flex-start"
                      alignItems="flex-start">
                    <Grid item xs={12} lg={12}>
                        <Typography variant="body1">
                            Erzeugte Sticker: <strong>{this.props.statStore.stats.totalStickers} </strong>
                            &middot; Aktivierte Sticker: <strong>{this.props.statStore.stats.activeStickers} </strong>
                            &middot; Benutzer mit aktiven Stickern: <strong>{this.props.statStore.stats.totalUsers} </strong>
                            &middot; Scans: <strong>{this.props.statStore.stats.totalScans} </strong>
                            &middot; Produkte: <strong>{this.props.statStore.stats.totalProducts} </strong>
                            &middot; Kunden: <strong>{this.props.statStore.stats.totalClients} </strong>
                            &middot; Druckaufträge: <strong>{this.props.statStore.stats.totalOrders} </strong>
                        </Typography>
                        <hr/>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Typography variant="subheading" align="center">
                            Aktivierte Sticker pro Monat
                        </Typography>
                        {this.props.statStore.stats ? (
                            <ResponsiveContainer width="99%" height={300}>
                                <LineChart
                                    data={this.props.statStore.stats.stickerActivations}
                                    margin={{
                                        top: 5, bottom: 5,
                                    }}>
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="timeframe" tick={{fontSize: 10}} tickFormatter={this.stripLabel}/>
                                    <YAxis/>
                                    <Tooltip formatter={(value) => [value, "Aktivierte Sticker"]} labelFormatter={(identifier) => 'Monat: ' + identifier}/>
                                    <Line type="monotone" dataKey="activations" stroke="#494949" strokeWidth="2"/>
                                </LineChart>
                            </ResponsiveContainer>
                        ) : (
                            <div>Loading...</div>
                        )}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Typography variant="subheading" align="center">
                            Top 10 Sticker (Anzahl Scans)
                        </Typography>
                        {this.props.statStore.stats ? (
                            <ResponsiveContainer width="99%" height={300}>
                                <BarChart
                                    data={this.props.statStore.stats.top10ScannedStickers}
                                    margin={{
                                        top: 5, bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="identifier" tick={{fontSize: 10}} tickFormatter={this.stripLabel}/>
                                    <YAxis dataKey="scans"/>
                                    <Tooltip formatter={(value) => [value, "Scans"]} labelFormatter={(identifier) => 'ID: ' + identifier}/>
                                    <Bar dataKey="scans" label={{fill: 'white', fontSize: 16}} fill="#F25E0E" onClick={this.handleBarClick}/>
                                </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <div>Loading...</div>
                        )}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Typography variant="subheading" align="center">
                            Top 10 Produkte (Anzahl Scans)
                        </Typography>
                        {this.props.statStore.stats ? (
                            <ResponsiveContainer width="99%" height={300}>
                                <BarChart
                                    data={this.props.statStore.stats.top10ScannedProducts}
                                    margin={{
                                        top: 5, right: 30, bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="name" tick={{fontSize: 10}} tickFormatter={this.stripLabel}/>
                                    <YAxis dataKey="scans"/>
                                    <Tooltip label="Scans" formatter={(value) => [value, "Scans"]} labelFormatter={(product) => 'Produkt: ' + product}/>
                                    <Bar dataKey="scans" label={{fill: 'white', fontSize: 16}} fill="#D9540C" onClick={this.handleBarClick}/>
                                </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <div>Loading...</div>
                        )}
                    </Grid>
                </Grid>
                <Grid container
                      direction="row"
                      justify="flex-start"
                      alignItems="flex-start">
                    <Grid item xs={12} lg={6}>
                        <Typography variant="subheading" align="center">
                            Top 10 Kunden (Anzahl Druckaufträge)
                        </Typography>
                        {this.props.statStore.stats ? (
                            <ResponsiveContainer width="99%" height={300}>
                                <BarChart
                                    data={this.props.statStore.stats.top10OrderingClients}
                                    margin={{
                                        top: 5, bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="company" tick={{fontSize: 10}} tickFormatter={this.stripLabel}/>
                                    <YAxis dataKey="orders"/>
                                    <Tooltip formatter={(value) => [value, "Druckaufträge"]} labelFormatter={(client) => 'Kunde: ' + client}/>
                                    <Bar dataKey="orders" label={{fill: 'white', fontSize: 16}} fill="#494949" onClick={this.handleBarClick}/>
                                </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <div>Loading...</div>
                        )}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Typography variant="subheading" align="center">
                            Top 10 Produkte (Anzahl Druckaufträge)
                        </Typography>
                        {this.props.statStore.stats ? (
                            <ResponsiveContainer width="99%" height={300}>
                                <BarChart
                                    data={this.props.statStore.stats.top10OrderedProducts}
                                    margin={{
                                        top: 5, right: 30, bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="name" tick={{fontSize: 10}} tickFormatter={this.stripLabel}/>
                                    <YAxis dataKey="orders"/>
                                    <Tooltip formatter={(value) => [value, "Druckaufträge"]} labelFormatter={(product) => 'Produkt: ' + product}/>
                                    <Bar dataKey="orders" label={{fill: 'white', fontSize: 16}} fill="#333333" onClick={this.handleBarClick}/>
                                </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <div>Loading...</div>
                        )}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(observer(Dashboard));
